<template>
      <!-- Main content -->
  <div class="main-content" id="panel">
    <!-- Topnav -->
    <!-- <Header /> -->
    <!-- Header -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2>Roles</h2>
            </div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <div class="container-fluid mt--6">
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive tbl-minh">
              <div v-if="loading"  class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" class="sort">Roles</th>
                    <th scope="col" class="sort"># Of Users</th>
                  </tr>
                </thead>
                <tbody class="list role">
                  <tr v-for="user in usersGroup" :key="user.groupName" data-toggle="modal" data-target="#userlist" @click="group = getGroupName(user.groupName) ;getUserList();">
                    <td class="btn-link">{{getGroupName(user.groupName)}}</td>
                    <td><span class="badge">{{user.userCount}}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
      <!-- user-list -->
      <div
        class="modal fade"
        id="userlist"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{this.group}} Users</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>

                <table class="table align-items-center table-flush table-hover bidtbl">
                  <thead class="thead-light psticky">
                    <tr>
                      <th 
                        scope="col" 
                        class="sort text-left"
                        v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                        @click="sort('firstName')" >Name</th>
                      <th 
                        scope="col" 
                        class="sort text-left"
                        v-bind:class="[sortOrder == 'ASC' && sortColumn == 'email'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'email'  ? 'sort-desc' : '']"  
                        @click="sort('email')">Email</th>
                      <th 
                        scope="col" 
                        class="sort text-left"
                        v-bind:class="[sortOrder == 'ASC' && sortColumn == 'createdAt'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'createdAt'  ? 'sort-desc' : '']"  
                        @click="sort('createdAt')">Created Date</th>
                      <th 
                        scope="col" 
                        class=" text-left"
                        >Phone Number</th>
                      <th 
                        scope="col" 
                        class=" text-left"
                        >Location</th>
                    </tr>
                  </thead>  
                  <tbody class="">
                    <tr v-if="totalRows == 0 && !loading">
                      <td><p class="nodata">No data available</p>
                      </td>
                    </tr>
                    <tr v-for="user in users" :key="user.Username">
                      <td class="text-left">{{user.firstName[0]}}. {{user.lastName}}</td>
                      <td class="text-left">{{user.email}}</td>
                      <td class="text-left">{{moment(user.createdAt).format("MM/DD/YYYY")}}</td>
                      <td class="text-left">{{user.phone}}</td>
                      <td class="text-left">{{user.address}}</td>
                    </tr>
                  </tbody>
                </table> 
                 <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getUserList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
  name: "admin-userRoles",
  data() {
    return {
      accessToken: null,
      usersGroup: [],
      config: config,
      loading : false,
      currentPage: 1,
      perPage: 10,
      searchValue : "",
      totalRows : 0,
      sortColumn: "firstName",
      sortOrder: "ASC",
      group:"",
      users: []
    };
  },
  created() {
  },
  methods: {
    getUserRoles(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/group/list",
            auth
        )
        .then(result => {
          this.usersGroup = result.data;
          this.loading = false;
          
        })
        .catch(e => {
          console.log(e);
        });
    },
    getGroupName(name){
      return name.split('-')[1];
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getUserList();
    },
    getUserGroupNames(group){
      var removedTenantName = group.map((groupName) => {
        return groupName.split('-')[1]
      });
      return removedTenantName.join(', ');
    },
    getUserList(currentPage){
      this.users  = [];
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      //console.log(auth);
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=ACTIVE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&group=" +
            this.group ,
            auth
        )
        .then(result => {
          console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
          this.users = result.data.content;
          this.loading = false;
          
        })
        .catch(e => {
          console.log(e);
        });
    },
  },
  mounted() {
  this.$cognitoAuth.getIdToken((err, result) => {
    if (err) {
      this.error = err;
    } else {
      this.accessToken = result;
      
      this.getUserRoles();

    }
  });
   
  }
};
</script>